import ActionButton from './ActionButton';

import { useSessionManagement } from '../hooks/useSession';

const LogoutButton = () => {
  const { signOut } = useSessionManagement();

  return <ActionButton label="logout" onClick={signOut} />;
};

export default LogoutButton;
